import UserDashboardHeader from "@/src/components/members/user-dashboard-header";
import AllBalances from "@/src/components/rewardly/balances/all-balances";
import MyStars from "@/src/components/rewardly/my-stars/my-stars";
import AllRecognitions from "@/src/components/rewardly/recognitions/all-recognitions";
import ConfigureTab from "@/src/components/rewardly/configure/configure-tab";
import ScTabs from "@/src/components/ui-kit/tabs";
import { REWARDLY_TAB_KEYS, RewardlyTabs } from "@/src/constants/rewardly-tabs";
import { useAuth } from "@/src/contexts/auth.context";
import { useState } from "react";
import { ScrollView, View } from "react-native";

const TAB_SUBTITLES: Record<RewardlyTabs, string> = {
	[RewardlyTabs.MY_STARS]: "LABEL_REWARDLY_SUBTITLE",
	[RewardlyTabs.BALANCE]: "LABEL_REWARDLY_BALANCE_SUBTITLE",
	[RewardlyTabs.RECOGNITIONS]: "LABEL_REWARDLY_RECOGNITIONS_SUBTITLE",
	[RewardlyTabs.CONFIGURE]: "LABEL_REWARDLY_CONFIGURE_SUBTITLE",
};

const Rewardly = () => {
	const { isAdmin } = useAuth();
	const [activeTab, setActiveTab] = useState<RewardlyTabs>(
		RewardlyTabs.MY_STARS,
	);

	const renderTabContent = () => {
		switch (activeTab) {
			case RewardlyTabs.BALANCE:
				return <AllBalances />;
			case RewardlyTabs.RECOGNITIONS:
				return <AllRecognitions />;
			case RewardlyTabs.CONFIGURE:
				return <ConfigureTab />;
			default:
				return <MyStars />;
		}
	};

	return (
		<View className="flex-row flex-1 bg-obsidian">
			<ScrollView
				className="flex-1"
				showsVerticalScrollIndicator={false}
				contentContainerClassName="grow"
			>
				<View className="flex-1 flex-col rounded-2xl gap-2">
					<View className="h-[96px] md:h-[130px]">
						<UserDashboardHeader subtitleKey={TAB_SUBTITLES[activeTab]} bgImageName="rewardly" />
					</View>

					<View className="flex-1 justify-start gap-4 md:bg-chalk md:rounded-2xl md:border md:border-ash-3 md:p-6">
						{/* Members only see "My stars"; the management tabs are admin views. */}
						{isAdmin && (
							<ScTabs
								tabs={REWARDLY_TAB_KEYS}
								active={activeTab}
								onChange={setActiveTab}
							/>
						)}
						<View className="flex-1">{renderTabContent()}</View>
					</View>
				</View>
			</ScrollView>
		</View>
	);
};

export default Rewardly;
